// lib/socket-events.ts
// Central place for socket event names that need to be shared between client and server bundles.
import type { GenerationOutputScope, ImageGenerationFailureDetails } from '#types/types';

export const LEASING_EVENT_NAME = 'leasing-event' as const;

// Credits
export const CREDITS_UPDATED_EVENT = 'credits-updated' as const;

export const PROJECT_CREDITS_UPDATED_EVENT = 'project-credits-updated' as const;

export const USER_PREFERENCES_UPDATED_EVENT = 'user-preferences-updated' as const;

export const TIMELINE_EXPORT_STATUS_EVENT = 'timeline-export-status' as const;

export const GENERATION_TASK_STATUS_EVENT = 'generation-task-status' as const;

// A phone/email lookup's live steps, to the user who started it: { contactId, ...FullEnrichProgress }.
export const CONTACT_LOOKUP_PROGRESS_EVENT = 'contact-lookup-progress' as const;

type GenerationTaskSocketStatus = 'RUNNING' | 'SUCCEEDED' | 'FAILED';

export interface GenerationTaskStatusSocketPayload {
  clientTaskId: string;
  generationTaskId?: string | null;
  generationLogId?: string | null;
  candidateVersionId?: string | null;
  layerId?: string | null;
  layerIds?: string[] | null;
  projectId?: string | null;
  workspaceId?: string | null;
  outputScope?: GenerationOutputScope | null;
  chatSessionId?: string | null;
  type?: string | null;
  model?: string | null;
  provider?: string | null;
  providerJobId?: string | null;
  status: GenerationTaskSocketStatus;
  outputUrl?: string | null;
  outputUrls?: string[] | null;
  errorMessage?: string | null;
  code?: 'IMAGE_GENERATION_BLOCKED' | 'IMAGE_GENERATION_NO_IMAGE';
  failureDetails?: ImageGenerationFailureDetails;
  createdAt: string;
  // Live progress telemetry (video-loop plan Phase 2/3). Emitted per-poll while a
  // long generation runs so the UI can show a determinate bar/ETA and the loop tier.
  progress?: number | null;        // 0..1 fraction complete (best-effort estimate)
  etaSeconds?: number | null;      // rough seconds remaining
  stepLabel?: string | null;       // e.g. "Rendering on Seedance Fast"
  loopTier?: 'direction' | 'motion' | 'render' | null; // which self-validation tier
}
